import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {discountLists_template} from "../components/templates/discountLists_template";

declare var ko: any;
declare var page: any;

export class discount_lists extends vnModule_knockoutJS {

    protected discountListsTemplate: discountLists_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected xhrHandlers: {[key: string]: XMLHttpRequestHandler} = {};

    protected DISCOUNT_FILTER_IDS = [
        'filter_featuredDiscounts',
    ];

    public static LIST_TYPES = [
        'featured_discounts',
        'popular_categories',
    ];

    protected getModuleName(): string {
        return "discount_lists";
    }

    buildContent(): Element[] {

        this.discountListsTemplate = new discountLists_template("discountListsTemplate", this.viewModel, this);
        this.template = this.discountListsTemplate;

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (loadedModule as header).setHeaderTitle("Discount Homepage");

        return [this.discountListsTemplate.build()];
    }

    public fillPage(): void {

        this.loadAllLists();
    }

    public getBrandId() {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    // ==========================================
    // NOTIFICATIONS
    // ==========================================

    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    // ==========================================
    // LOADING DATA
    // ==========================================

    protected loadAllLists(): void {

        this.discountListsTemplate.activateLoading();

        const listTypes = discount_lists.LIST_TYPES;
        let loadedCount = 0;

        for (const listType of listTypes) {
            this.loadDiscountList(listType, () => {
                loadedCount++;
                if (loadedCount >= listTypes.length) {
                    this.discountListsTemplate.deactivateLoading();
                }
            });
        }
    }

    protected loadDiscountList(listType: string, onComplete?: () => void): void {

        const key = 'list_' + listType;
        if (this.xhrHandlers[key]) {
            this.xhrHandlers[key].cancelAndReset();
        }

        const url: string = '/api/discounts/curated/' + listType + '/';
        const params: string[][] = [];

        this.xhrHandlers[key] = new XMLHttpRequestHandler(url, params, this);
        this.xhrHandlers[key].onReadyStateFunction = this.onGetDiscountListReturn(listType, onComplete);
        this.xhrHandlers[key].execute();
    }

    protected onGetDiscountListReturn(listType: string, onComplete?: () => void) {

        const self = this;
        return function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    const response = JSON.parse(req.request.response);
                    const items = response.items || [];
                    self.discountListsTemplate.setItemSectionData(listType, items);
                });
                if (onComplete) onComplete();
            };
        };
    }

    // ==========================================
    // SEARCH / SUGGESTIONS (featured discounts only)
    // ==========================================

    /**
     * Called by filterAutocomplete_template when user types in the search box.
     */
    protected getSuggestions(keyword, idSourceElement): void {

        if (this.DISCOUNT_FILTER_IDS.indexOf(idSourceElement) !== -1) {
            this.searchDiscounts(keyword, idSourceElement);
        }
    }

    /**
     * Search discounts via API.
     */
    protected searchDiscounts(keyword: string, idSourceElement: string): void {

        const key = 'search_' + idSourceElement;
        if (this.xhrHandlers[key]) {
            this.xhrHandlers[key].cancelAndReset();
        }

        const url: string = '/api/discounts/get/';
        const params: string[][] = [];
        params.push(["data", ko.toJSON({
            filters: { keyword: keyword },
            pagination: { pageNumber: 1, itemPerPage: 20 },
            orderBy: 'name',
            orderByDirection: 'ASC'
        })]);

        this.xhrHandlers[key] = new XMLHttpRequestHandler(url, params, this);
        this.xhrHandlers[key].onReadyStateFunction = this.onSearchDiscountsReturn(idSourceElement);
        this.xhrHandlers[key].execute();
    }

    protected onSearchDiscountsReturn(idSourceElement: string) {

        const self = this;
        return function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    const response = JSON.parse(req.request.response);
                    const discounts = response.discounts || response.data || [];
                    const options = discounts.map(d => ({
                        id:                    d.id,
                        name:                  d.name,
                        slug:                  d.slug,
                        displayNameComplement: d.name + (d.merchant && d.merchant.name ? ' (' + d.merchant.name + ')' : ''),
                        isSelectable:          1
                    }));
                    self.discountListsTemplate.setItemFilterOptions(idSourceElement, options);
                });
            };
        };
    }

    // ==========================================
    // SAVING
    // ==========================================

    public saveHomepage(): void {

        if (this.xhrHandlers['save_homepage']) {
            this.xhrHandlers['save_homepage'].cancelAndReset();
        }

        this.discountListsTemplate.activateLoading();

        const lists = this.discountListsTemplate.getAllListData();

        const url: string = '/api/discounts/curated-homepage/';
        const params: string[][] = [];
        params.push(["data", ko.toJSON({ lists: lists })]);

        this.xhrHandlers['save_homepage'] = new XMLHttpRequestHandler(url, params, this);
        this.xhrHandlers['save_homepage'].mode = XMLHttpRequestHandler_requestType.POST;
        this.xhrHandlers['save_homepage'].onReadyStateFunction = this.onSaveHomepageReturn();
        this.xhrHandlers['save_homepage'].execute();
    }

    protected onSaveHomepageReturn() {

        const self = this;
        return function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_SUCCESS,
                        'Discount homepage saved successfully!'
                    );
                    obj.getVnAppZone().showNotificationToModule();

                    self.loadAllLists();
                });

                obj.discountListsTemplate.deactivateLoading();
            };
        };
    }

    // ==========================================
    // Required stubs for vnModule_knockoutJS
    // ==========================================

    protected onAutocompleteOptionChange(idElement): void {}
    protected onAutocompleteInputClear(idElement): void {}
    protected onAutocompleteInputClick(idElement): void {}
    protected onAutocompleteAddNewSelected(idElement): void {}
    protected onAutocompleteAddNewInputChange(idElement?): void {}
    protected onAutocompleteAddNewInputClick(idElement): void {}
    protected onPromptInputChangeClear(idElement): void {}
    protected onAutocompleteAcceptSuggestion(idElement): void {}

    protected filterSimpleOnChange(idElement) {}
    protected filterSimpleCancel() {}
    protected filterDropdownOnChange(idElement) {}
    protected filterMultipleSelectorOnChange() {}
}



// WEBPACK FOOTER //
// ./js/modules/discount_lists.ts